import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

const Sidebar = () => {
  const navigate = useNavigate();
  const { currentUser, logout } = useAuth();
  const [showUserMenu, setShowUserMenu] = useState(false);

  const navLinkClasses =
    'flex items-center gap-3 px-3 py-2.5 rounded-lg text-neutral-600 hover:bg-neutral-100 hover:text-neutral-900 transition-all duration-200 group';
  const activeNavLinkClasses = 'bg-primary-100 text-primary-700 font-medium';

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  return (
    <aside className="hidden md:flex flex-col w-64 bg-white border-r border-neutral-200 flex-shrink-0">
      <div className="p-6 flex flex-col h-full justify-between">
        <div className="flex flex-col gap-8">
          {/* Brand Logo */}
          <div className="flex flex-col">
            <img
              src="/EzyPipe_full_coloredlogo-login_300.png"
              alt="EzyPipe - Gmail CRM for Freelancers"
              className="h-14"
            />
          </div>

          {/* Menu Items */}
          <nav className="flex flex-col gap-1">
            <NavLink
              to="/"
              end
              className={({ isActive }) => `${navLinkClasses} ${isActive ? activeNavLinkClasses : ''}`}
            >
              <span className="material-symbols-outlined text-[22px]">dashboard</span>
              <span className="text-sm">Dashboard</span>
            </NavLink>

            <NavLink
              to="/pipeline"
              className={({ isActive }) => `${navLinkClasses} ${isActive ? activeNavLinkClasses : ''}`}
            >
              <span className="material-symbols-outlined text-[22px]">view_kanban</span>
              <span className="text-sm">Pipeline</span>
            </NavLink>

            <NavLink
              to="/contacts"
              className={({ isActive }) => `${navLinkClasses} ${isActive ? activeNavLinkClasses : ''}`}
            >
              <span className="material-symbols-outlined text-[22px]">contacts</span>
              <span className="text-sm">Contacts</span>
            </NavLink>

            <NavLink
              to="/companies"
              className={({ isActive }) => `${navLinkClasses} ${isActive ? activeNavLinkClasses : ''}`}
            >
              <span className="material-symbols-outlined text-[22px]">business</span>
              <span className="text-sm">Companies</span>
            </NavLink>

            <NavLink
              to="/settings"
              className={({ isActive }) => `${navLinkClasses} ${isActive ? activeNavLinkClasses : ''}`}
            >
              <span className="material-symbols-outlined text-[22px]">settings</span>
              <span className="text-sm">Settings</span>
            </NavLink>
          </nav>
        </div>

        <div className="flex flex-col gap-3">
          {/* CTA */}
          <button
            onClick={() => navigate('/pipeline', { state: { openNewDeal: true } })}
            className="w-full flex cursor-pointer items-center justify-center rounded-lg h-11 px-4 bg-primary text-white text-sm font-semibold shadow-md shadow-primary/25 hover:bg-primary-500 hover:-translate-y-0.5 transition-all duration-200"
          >
            <span className="material-symbols-outlined text-[20px] mr-2">add</span>
            <span>New Opportunity</span>
          </button>

          {/* User Profile */}
          <div className="relative">
            <button
              onClick={() => setShowUserMenu(!showUserMenu)}
              className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg hover:bg-neutral-100 transition-colors"
            >
              <div className="bg-primary-100 rounded-full size-9 flex items-center justify-center">
                <span className="material-symbols-outlined text-primary text-[20px]">person</span>
              </div>
              <div className="flex-1 text-left overflow-hidden">
                <p className="text-sm font-medium text-neutral-900 truncate">
                  {currentUser?.displayName || 'User'}
                </p>
                <p className="text-xs text-neutral-500 truncate">
                  {currentUser?.email}
                </p>
              </div>
              <span className="material-symbols-outlined text-neutral-400 text-[20px]">
                {showUserMenu ? 'expand_less' : 'expand_more'}
              </span>
            </button>

            {showUserMenu && (
              <div className="absolute bottom-full left-0 right-0 mb-2 bg-white border border-neutral-200 rounded-lg shadow-lg overflow-hidden animate-fade-in">
                <button
                  onClick={handleLogout}
                  className="w-full flex items-center gap-3 px-3 py-2.5 text-left text-sm text-error hover:bg-error-light transition-colors"
                >
                  <span className="material-symbols-outlined text-[20px]">logout</span>
                  <span>Logout</span>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
